import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { ReferenceSelector } from "@/.storyblok/types/319751/storyblok-components";

interface ReferenceSelectorProps {
  blok?: ReferenceSelector & SbBlokData;
}

const ReferenceSelectorComponent: React.FC<ReferenceSelectorProps> = ({ blok }) => {
  if (!blok || !blok.select_story || blok.select_story.length === 0) return null;

  return (
    <main {...(blok._editable && storyblokEditable(blok))}>
      <ul>
        {blok.select_story.map((storyId) => (
          <li key={storyId}>{storyId}</li>
        ))}
      </ul>
    </main>
  );
};

export default ReferenceSelectorComponent;